module.exports = __webpack_public_path__ + "img/panelView_2_1.copy.f7dab8fb.png";